import styled from "styled-components";
import { useState, createContext } from "react";
import SpinnerOverlay from "../Components/UI/SpinnerOverlay/SpinnerOverlay";

interface SpinnerContextType {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SpinnerContext = createContext<SpinnerContextType>({
  isLoading: true,
  setIsLoading: () => {},
});

export default function SpinnerContextProvider(props: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <SpinnerContext.Provider value={{ isLoading, setIsLoading }}>
      {isLoading && <SpinnerOverlay />}
      {props.children}
    </SpinnerContext.Provider>
  );
}

interface Props {
  children: React.ReactNode;
}
